module.exports = __webpack_public_path__ + "img/game_icon_assist.0011a1a5.png";